// FormRegisterScheme.js
import * as Yup from "yup";

export const FormRegisterScheme = () =>
  Yup.object().shape({
    name: Yup.string().required("El nombre es obligatorio").trim(),
    email: Yup.string().email("Correo electrónico inválido").required("El correo es obligatorio").trim(),
    // FormRegisterScheme()
    phone: Yup.string()
      .transform((v) => (v || "").replace(/\D/g, "")) // ← limpia aquí
      .required("El teléfono es obligatorio")
      .length(10, "Debe ser un teléfono válido de 10 dígitos"),
    password: Yup.string().min(5, "La contraseña debe tener al menos 5 caracteres").required("La contraseña es obligatoria").trim(),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden").required("Debes confirmar la contraseña").trim(),
    role: Yup.string().oneOf(["cliente", "comerciante", "repartidor"], "Rol inválido").default("cliente"),

    address: Yup.string()
      .required("La dirección es obligatoria")
      .min(8, "Escribe una dirección más específica"),
    lat: Yup.string()
      .required("La latitud es obligatoria")
      .test("lat-num", "Latitud inválida", (v) => !isNaN(Number(v))),
    lng: Yup.string()
      .required("La longitud es obligatoria")
      .test("lng-num", "Longitud inválida", (v) => !isNaN(Number(v))),
  });